var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import styled from "styled-components";
import { MdOpenInNew } from "react-icons/md";
import Icon from "onnit-ui/lib/icon/Icon";
var NewExternalLinkIconSvg = styled.span.attrs(function (p) { return ({}); })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    svg {\n        display: inline-block;\n        vertical-align: middle;\n        margin-left: 3px;\n        fill: currentColor;\n    }\n"], ["\n    svg {\n        display: inline-block;\n        vertical-align: middle;\n        margin-left: 3px;\n        fill: currentColor;\n    }\n"])));
var NewWindowIndicator = function (_a) {
    var _b = _a.noExternalLinkIcon, noExternalLinkIcon = _b === void 0 ? false : _b, _c = _a.width, width = _c === void 0 ? 14 : _c, _d = _a.height, height = _d === void 0 ? 14 : _d, _e = _a.title, title = _e === void 0 ? "Opens in new window." : _e, rest = __rest(_a, ["noExternalLinkIcon", "width", "height", "title"]);
    return (noExternalLinkIcon ?
        (React.createElement("span", { className: "sr-only" }, title))
        : (React.createElement(NewExternalLinkIconSvg, __assign({}, rest),
            React.createElement(Icon, { width: width, height: height, title: title, icon: MdOpenInNew }))));
};
export default NewWindowIndicator;
var templateObject_1;
//# sourceMappingURL=NewWindowIndicator.js.map